import React from 'react';
import { usePermissions } from '../../contexts/PermissionsContext';
import './PermissionGate.css';

interface PermissionGateProps {
    permission: 'staffCanViewAnalytics' | 'staffCanViewCashflow' | 'staffCanManageMenu' |
    'staffCanViewDocuments' | 'staffCanManageEvents' | 'staffCanViewOrders' |
    'staffCanManageLocations' | 'staffCanViewBranding' | 'staffCanManagePrintCenter' | 'staffCanManageUsers';
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

export const PermissionGate: React.FC<PermissionGateProps> = ({
    permission,
    children,
    fallback
}) => {
    const { canAccess, loading, isStaff } = usePermissions();

    // Se non è staff, mostra normalmente (è admin)
    if (!isStaff) {
        return <>{children}</>;
    }

    if (loading) {
        return <div className="permission-loading">Caricamento...</div>;
    }

    // Se lo staff non ha il permesso, mostra il fallback
    if (!canAccess(permission)) {
        if (fallback) {
            return <>{fallback}</>;
        }

        return (
            <div className="permission-denied-container">
                <div className="permission-denied-card">
                    <div className="lock-icon">🔒</div>
                    <h2>Accesso Limitato</h2>
                    <p>Non hai i permessi necessari per accedere a questa sezione.</p>
                    <p className="contact-admin">Contatta un amministratore per richiedere l'accesso.</p>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};
